<template>
  <div ref="side_ads" class="side-ads ad-slot">
    <div class="ad_container">
      <div class="ad_wrapper">
        <div v-if="screen.isDesktop" id="div-gpt-ad-1556609030596-0"></div>
        <div v-else id="div-gpt-ad-1556161782064-0"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'side-ads',
  computed: {
    screen() {
      return this.$store.state.screen;
    },
  },
  mounted() {
    if (document.readyState == 'complete') {
      this.loadAds();
    } else {
      document.addEventListener(
        'scriptReady',
        (e) => {
          this.loadAds();
        },
        true
      );
    }
  },
  methods: {
    loadAds() {
      const el = this;
      googletag.cmd.push(() => {
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
          if (event.isEmpty) {
            const id = event.slot.getSlotElementId();
            if (id) {
              if (el.$refs['top-ads'] && el.$refs['top-ads'].classList.contains('ad-slot')) {
                el.$refs['top-ads'].style.display = 'none';
              }
            }
            if (el.$refs['side_ads'] && el.$refs['side_ads'].classList.contains('ad-slot')) {
              el.$refs['side_ads'].style.display = 'none';
            }
          }
        });

        if (this.$store.state.screen.isDesktop) {
          googletag
            .defineSlot('/187290464/Revamp_Desktop_SideBanner', [240, 400], 'div-gpt-ad-1556609030596-0')
            .addService(googletag.pubads())
            .setCollapseEmptyDiv(true);
          googletag.enableServices();
          googletag.display('div-gpt-ad-1556609030596-0');
        } else {
          googletag
            .defineSlot('/187290464/Revamp_Mobile_SideBanner', [320, 50], 'div-gpt-ad-1556161782064-0')
            .addService(googletag.pubads())
            .setCollapseEmptyDiv(true);
          googletag.enableServices();
          googletag.display('div-gpt-ad-1556161782064-0');
        }
      });
    },
  },
};
</script>

<style lang="scss">
.ad_container {
  text-align: center;
}

.ad_wrapper {
  display: inline-block;
  position: relative;
}
</style>
